class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
    this.querySelector(".discountcode-btn").addEventListener("click", this.setDiscount.bind(this));
    this.querySelectorAll(".discounts__discount").forEach((item) => {
      item.addEventListener("click", this.setDiscount.bind(this));
    });
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  async setDiscount(event){
      document.querySelector(".discount-loading__spinner").classList.remove("hidden");
      document.querySelector(".cart-drawer-discount-container").classList.add("unshow");    
      const response = await fetch(`/cart.js`);
      if (response.ok) {
        const responseJson = await response.json();
        if(responseJson.cart_level_discount_applications.length > 0){
           this.discountFisrtCode = responseJson.cart_level_discount_applications[0].title || '';
        }else if(responseJson.items.length > 0 && responseJson.items[0].discounts.length > 0){
           this.discountFisrtCode = responseJson.items[0].discounts[0].title || '';
        }
        this.token = responseJson.token;
      }
      
      // 检查购物车token是否存在
      if (!this.token) {
        const tips = document.querySelector(".cart-drawer-discount-error");
        tips.innerText = tips.getAttribute('data-tips-error');
        setTimeout(() => {
            document.querySelector(".discount-loading__spinner").classList.add("hidden");
            document.querySelector(".cart-drawer-discount-container").classList.remove("unshow");
        }, 2000);
        return;
      }
      
      console.log('购物车token:', this.token);
      
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      const discountCode = this.querySelector("input[name=discount]").value;
      
      // 使用REST API应用折扣码
      const formData = new FormData();
      formData.append('discount', discountCode);
      
     const tips = document.querySelector(".cart-drawer-discount-error");
      
      fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
        body: JSON.stringify({
          discount: discountCode
        })
        })
        .then(response => response.json())
        .then(data => {
        console.log('折扣码应用结果:', data);
        
        // 添加调试信息
        console.log('购物车级别折扣:', data.cart_level_discount_applications);
        console.log('商品级别折扣:', data.items && data.items.length > 0 ? data.items[0].discounts : '无商品');
        console.log('购物车总价:', data.total_price);
        console.log('购物车折扣总额:', data.total_discount);
        
        // 检查是否有错误
        if (data.errors) {
          console.error('折扣码应用错误:', data.errors);
          tips.innerText = tips.getAttribute('data-tips-error');
          setTimeout(() => {
              document.querySelector(".discount-loading__spinner").classList.add("hidden");
              document.querySelector(".cart-drawer-discount-container").classList.remove("unshow");
          }, 2000);
          return;
        }
        
        // 检查折扣码是否成功应用
        // 更完善的验证逻辑：检查多种折扣应用情况
        const hasCartLevelDiscount = data.cart_level_discount_applications && data.cart_level_discount_applications.length > 0;
        const hasItemLevelDiscount = data.items && data.items.length > 0 && data.items.some(item => item.discounts && item.discounts.length > 0);
        const hasItemDiscountAllocations = data.items && data.items.length > 0 && data.items.some(item => item.line_level_discount_allocations && item.line_level_discount_allocations.length > 0);
        const hasTotalDiscount = data.total_discount && data.total_discount > 0;
        
        console.log('购物车级别折扣存在:', hasCartLevelDiscount);
        console.log('商品级别折扣存在:', hasItemLevelDiscount);
        console.log('商品级别折扣分配存在:', hasItemDiscountAllocations);
        console.log('总折扣存在:', hasTotalDiscount);
        
        // 如果任何一种折扣存在，就认为折扣码应用成功
        if (hasCartLevelDiscount || hasItemLevelDiscount || hasItemDiscountAllocations || hasTotalDiscount) {
          console.log('折扣码验证成功，更新购物车抽屉');
          this.updateCartDrawer(false);
        } else {
          console.log('折扣码验证失败，显示错误提示');
          tips.innerText = tips.getAttribute('data-tips-error');
          setTimeout(() => {
              document.querySelector(".discount-loading__spinner").classList.add("hidden");
              document.querySelector(".cart-drawer-discount-container").classList.remove("unshow");
          }, 2000);
        }
       })
      .catch(error => {
          console.error('网络请求错误:', error);
          tips.innerText = tips.getAttribute('data-tips-error');
          setTimeout(() => {
              document.querySelector(".discount-loading__spinner").classList.add("hidden");
              document.querySelector(".cart-drawer-discount-container").classList.remove("unshow");
            }, 2000);
       });    
  }
  updateCartDrawer(removeCode){
    const tips = document.querySelector(".cart-drawer-discount-error");
    fetch(`${routes.cart_url}?section_id=cart-drawer`)
      .then((response) => response.text())
      .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const sourceQty = html.querySelector('cart-drawer');
          document.querySelector("cart-drawer").innerHTML = sourceQty.innerHTML;
          document.querySelector(".discountcode-btn").addEventListener("click", this.setDiscount.bind(this));
          document.querySelectorAll(".discounts__discount").forEach((item) => {
            item.addEventListener("click", this.setDiscount.bind(this));
          });
          if(removeCode){
            document.querySelector(".cart-drawer-discount-error").innerText = tips.getAttribute('data-tips');
          }else{
            document.querySelector(".cart-drawer-discount-error").innerText = tips.getAttribute('data-tips-success');         
          }
          
     })
     .catch((e) => {
        document.querySelector(".cart-drawer-discount-error").innerText = tips.getAttribute('data-tips-error');
     });    
  }
  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
